// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G99-g","col":"styles_col__NnFy3"};